module.exports = __webpack_public_path__ + "static/media/2.87d0709a.jpg";